{
  "DATA_ASSISTANT": {
    "TITLE": "Asistente de datos",
    "NEW_CONVERSATION": "+ Nueva",
    "LOADING": "Cargando...",
    "LOADING_MESSAGES": "Cargando mensajes...",
    "THINKING": "Pensando...",
    "UNTITLED": "Conversación sin título",
    "NO_CONVERSATIONS": "Aún no hay conversaciones. Haz clic en \"+ Nueva\" para empezar.",
    "EMPTY_STATE": "Selecciona una conversación o crea una nueva para empezar.",
    "SEND": "Enviar",
    "PLACEHOLDER": "¿Qué puedo averiguar para ti?",
    "SHOW_SQL": "Mostrar SQL",
    "NO_ROWS": "No se devolvieron filas.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Eliminar conversación",
    "DELETE_CONFIRM_DESCRIPTION": "¿Estás seguro de que deseas eliminar esta conversación? Esta acción no se puede deshacer.",
    "DELETE_CONFIRM_YES": "Eliminar",
    "CHAT": "Chat",
    "REPORTS": "Informes",
    "SAVE_TO_REPORT": "Guardar en informe",
    "NEW_REPORT": "Nuevo informe",
    "REPORT_NAME": "Nombre del informe",
    "NO_REPORTS": "Aún no hay informes guardados",
    "REPORTS_EMPTY_STATE": "Selecciona un informe o crea uno nuevo.",
    "REPORT_SAVED": "Guardado en el informe",
    "DELETE_REPORT_CONFIRM": "Eliminar informe",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "¿Estás seguro de que deseas eliminar este informe? Se eliminarán todos los elementos guardados.",
    "DELETE_ITEM_CONFIRM": "Eliminar elemento",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "¿Estás seguro de que deseas eliminar este elemento del informe?",
    "EXPORT_CSV": "Exportar CSV",
    "REFRESH": "Actualizar",
    "QUERY_RUNNING": "Ejecutando consulta...",
    "QUERY_FAILED": "La consulta falló",
    "AUTO_REFRESH": "Actualización automática",
    "AUTO_REFRESH_NONE": "Manual",
    "AUTO_REFRESH_30S": "30 segundos",
    "AUTO_REFRESH_1M": "1 minuto",
    "AUTO_REFRESH_5M": "5 minutos",
    "AUTO_REFRESH_10M": "10 minutos",
    "EDIT_MESSAGE": "Editar mensaje",
    "RENAME_REPORT": "Renombrar informe",
    "RENAME_ITEM": "Renombrar elemento",
    "MOVE_UP": "Mover arriba",
    "MOVE_DOWN": "Mover abajo",
    "COLLABORATORS": {
      "BUTTON": "Colaboradores",
      "TITLE": "Colaboradores del informe",
      "DESCRIPTION": "Elige qué agentes y equipos pueden ver este informe.",
      "AGENTS": "Agentes",
      "TEAMS": "Equipos",
      "SELECT_AGENTS": "Seleccionar agentes",
      "SELECT_TEAMS": "Seleccionar equipos",
      "SAVE": "Guardar",
      "SAVED": "Colaboradores actualizados",
      "SAVE_FAILED": "No se pudieron actualizar los colaboradores"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Informes"
}
